<div class="csd-snackbar csd-snackbar--{{ data.variant }}">
  <div class="csd-snackbar__body">
    <mat-icon class="csd-snackbar__icon" aria-hidden="true">{{ icon }}</mat-icon>

    <div class="csd-snackbar__text">
      <p class="csd-snackbar__title" data-testid="snackbar-title">{{ data.title }}</p>
      @if (data.message) {
        <p class="csd-snackbar__message" data-testid="snackbar-message">{{ data.message }}</p>
      }
    </div>
  </div>

  <button
    type="button"
    class="csd-snackbar__close"
    aria-label="Dismiss notification"
    data-testid="snackbar-close"
    (click)="dismiss()"
  >
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</div>
